import { User } from '../services/graphql/types/User';

export const dateTimeToUnix = (dateTime: number) => Math.floor(dateTime / 1000);

export const toUnixTime = (
    year: number,
    month: number,
    day: number | undefined,
    hr: number | undefined,
    min: number | undefined,
    sec: number | undefined,
) => {
    const date = new Date(Date.UTC(year, month - 1, day, hr, min, sec));
    return dateTimeToUnix(date.getTime());
};

export const getFullUserName = (user?: User): string => {
    if (!user) {
        return '';
    }

    const userFullName = [user.userGivenName, user.userSurname]
        .filter(Boolean)
        .join(' ');
    const userHasFullName = userFullName.trim().length > 0;

    if (userHasFullName) {
        return userFullName;
    }

    return user.email;
};

// biome-ignore lint/suspicious/noExplicitAny: inherited from operator
export const getDefaultAvatarUrl = (user: any) => {
    const preferredName = user.userPreferredName || user.userGivenName || '';
    const initials = getInitials(preferredName, user.userSurname);

    // Validate if avatarUrl is a valid URL
    const isUrl = /^https?:\/\/\S+$/i.test(user.avatarUrl);

    // Return initials if avatarUrl is null, otherwise return avatarUrl
    return {
        isUrl: isUrl,
        avatar: user.avatarUrl === null || !isUrl ? initials : user.avatarUrl,
    };
};
const getInitials = (firstName: string, lastName: string) => {
    const firstInitial = firstName ? firstName.charAt(0) : '';
    const lastInitial = lastName ? lastName.charAt(0) : '';
    return `${firstInitial}${lastInitial}`;
};
